import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PublicNoticesUIHelpers";

const PublicNoticesUIContext = createContext();

export function usePublicNoticesUIContext() {
  return useContext(PublicNoticesUIContext);
}

export const PublicNoticesUIConsumer = PublicNoticesUIContext.Consumer;

export function PublicNoticesUIProvider({ publicNoticesUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewPublicNoticePage: publicNoticesUIEvents.openNewPublicNoticePage,
    openPublicNoticeDetailPage: publicNoticesUIEvents.openPublicNoticeDetailPage
  };

  return (
    <PublicNoticesUIContext.Provider value={value}>
      {children}
    </PublicNoticesUIContext.Provider>
  );
}